import { gql } from '@apollo/client';

export const GET_EMAIL_CAMPAIGN_RECIPIENT_COUNT = gql`
    query GetEmailCampaignRecipientCount($data: EmailTargetingOptionsInput) {
        getEmailCampaignRecipientCount(data: $data) {
            count
            breakdown
            excludedBreakdown {
                totalVerified
                excludedUnsubscribed
                excludedDeleted
                excludedHardBounce
                excludedSpamReport
                excludedSoftBounceLimit
                excludedProUsers
            }
        }
    }
`;

